export default function forEach<T>(
  collection: T[] | Record<keyof object, T>,
  callback: (
    value: T,
    index: string | number,
    collection: T[] | { [key: string]: T },
  ) => void,
  scope?: unknown,
): void {
  if (Array.isArray(collection)) {
    for (let i = 0, len = collection.length; i < len; i++) {
      callback.call(scope, collection[i], i, collection)
    }
  } else {
    for (const prop in collection) {
      if (Object.prototype.hasOwnProperty.call(collection, prop)) {
        callback.call(scope, collection[prop], prop, collection)
      }
    }
  }
}
